// extracted by mini-css-extract-plugin
export var statItem = "_l3-1";
export var statsRow = "_l3-0";